import React from 'react';
import PropTypes from 'prop-types';
import { PillWithIcon } from '@els/els-react--pill';
import bannerBackground1024 from '@assets/avif/Banner-background-PR-1024.avif';
import bannerBackground1440 from '@assets/avif/Banner-background-PR-1440.avif';
import bannerBackground1920 from '@assets/avif/Banner-background-PR-1920.avif';

import './ResultsPreviewAIBanner.scss';

const bannerBackgroundSrcSet = `${bannerBackground1024} 1024w, ${bannerBackground1440} 1440w, ${bannerBackground1920} 1920w`;

function ResultsPreviewAIBanner({ className = '' }) {
  return (
    <div className={`results-preview-ai-banner u-els-margin-bottom ${className}`.trim()}>
      <picture className="results-preview-ai-banner__picture">
        <img
          src={bannerBackground1024}
          srcSet={bannerBackgroundSrcSet}
          sizes="100vw"
          alt=""
          aria-hidden="true"
          className="results-preview-ai-banner__image"
          decoding="async"
          loading="eager"
        />
      </picture>
      <PillWithIcon
        iconProps={{ sprite: 'AI' }}
        iconColor="text"
        iconRight
        condensed
        pillColor="extended-blue-0"
        textColor="text"
        className="results-preview-ai-banner__pill">
        AI
      </PillWithIcon>
      <h3 className="results-preview-ai-banner__title">Change the way you review results; start here with AI-driven insights.</h3>
    </div>
  );
}

ResultsPreviewAIBanner.propTypes = {
  className: PropTypes.string,
};

export default ResultsPreviewAIBanner;
